module.exports = __webpack_public_path__ + "img/10800.4722de64.jpg";